import React from 'react';
import ThemeCardThemeStatus from './ThemeCardThemeStatus';
import LinkedContainer from './theme-card/LinkedContainer';
import Container from './theme-card/Container';
import ParentName from './theme-card/ParentName'
import ThemeName from './theme-card/ThemeName';
import thronThumbnailResize from '../utils/thronThumbnailResize';
import remToPixels from '../utils/remToPixels';

function generateLink(theme) {
  return theme.parentType === 'collections'
    ? `/seasonal/${theme.parentId}/themes/${theme.id}`
    : `/timeless/${theme.parentId}/themes/${theme.id}`
}

export default ({ theme, ...props }) => (
  <LinkedContainer {...props} related="true" to={generateLink(theme)}>
    <Container cover={thronThumbnailResize(theme.cover, { width: remToPixels(12.75) })} related="true">
      <ParentName related="true">{theme.parentName}</ParentName>
      <ThemeCardThemeStatus light small status={theme.status} style={{ marginBottom: '1rem', }}/>
      <ThemeName related="true">{theme.name}</ThemeName>
    </Container>
  </LinkedContainer>
);
